import {
  Autocomplete,
  Button,
  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Admin_Region_Name } from "../../../../constants";
import axios from "axios";

const BranchFilter = ({ filters, setFilters, onApplyFilters }) => {
  const [regionList, setRegionList] = useState([]);
  const [regionLoading, setRegionLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilters((prevFilters) => ({ ...prevFilters, [name]: value }));
  };

  const fetchRegion = async () => {
    try {
      const response = await axios.get(`${Admin_Region_Name}`);
      setRegionList(response.data.data || []);
    } catch (error) {
      console.error("Error fetching attendance data:", error);
    }
  };

  useEffect(() => {
    fetchRegion();
  }, []);

  const handleRegionAutocompleteChange = (event, newValue) => {
    setFilters((prev) => ({
      ...prev,
      regionId: newValue ? newValue.RegionId : "",
    }));
  };

  const resetFilters = () => {
    const reset = { regionId: "", searchText: "", Zone: "" };
    setFilters(reset);
    onApplyFilters(reset);
  };

  return (
    <>
      <Paper elevation={2} sx={{ mb: 4, p: 3 }}>
        <Grid container spacing={2} alignItems="center">
          {/* Left side: Search + Region */}
          <Grid item xs={12} md={9}>
            <Grid container spacing={2}>
              {/* Search */}
              <Grid item xs={12} sm={4} md={4}>
                <FormControl fullWidth>
                  <TextField
                    label="Search by Name or Zone"
                    name="searchText"
                    value={filters.searchText}
                    onChange={(e) => handleInputChange(e)}
                    size="small"
                  />
                </FormControl>
              </Grid>

              {/* Region Filter */}
              <Grid item xs={12} sm={4} md={4}>
                <Autocomplete
                  options={regionList}
                  getOptionLabel={(option) => option.RegionName || ""}
                  value={
                    regionList.find(
                      (type) => type.RegionId === filters.regionId
                    ) || null
                  }
                  onChange={handleRegionAutocompleteChange}
                  onOpen={fetchRegion}
                  loading={regionLoading}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Region"
                      variant="outlined"
                      size="small"
                      fullWidth
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {regionLoading ? (
                              <CircularProgress color="inherit" size={20} />
                            ) : null}
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                />
              </Grid>
            </Grid>
          </Grid>

          {/* Right side: Action buttons */}
          <Grid
            item
            xs={12}
            md={3}
            sx={{
              textAlign: { xs: "left", md: "right" },
              display: "flex",
              justifyContent: { xs: "flex-start", md: "flex-end" },
              alignItems: "center",
            }}
          >
            <Button
              variant="outlined"
              size="small"
              onClick={() => {
                resetFilters();
              }}
              sx={{ mr: 1 }}
            >
              Reset Filters
            </Button>

            <Button
              variant="outlined"
              size="small"
              onClick={() => onApplyFilters(filters)}
              sx={{ mr: 1 }}
            >
              Apply Filters
            </Button>
          </Grid>
        </Grid>
      </Paper>
    </>
  );
};

export default BranchFilter;
